import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getDefaultPaymentMethod, getAllPaymentMethods, getUser } from 'reducers';

import { getAll } from './actions';

const paymentMethodsDecorator = (DecoratedComponent) => {

  class PaymentMethodsDecorator extends Component {
    componentDidMount() {
      this.fetchPaymentMethods();
    }

    componentDidUpdate(oldProps) {
      if (this.props.userId !== oldProps.userId) {
        this.fetchPaymentMethods();
      }
    }

    fetchPaymentMethods() {
      const { userId, getAll } = this.props;
      userId && getAll(userId);
    }

    render() {
      const { children, getAll, ...props } = this.props;

      return React.createElement(
        DecoratedComponent,
        props,
        children
      );
    }
  }

  const mapStateToProps = (state) => ({
    userId: getUser(state) && getUser(state).id,
    defaultPaymentMethod: getDefaultPaymentMethod(state),
    paymentMethods: getAllPaymentMethods(state),
  });

  const mapDispatchToProps = {
    getAll,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(PaymentMethodsDecorator);
}

export default paymentMethodsDecorator;
